/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface UpdateSectionRequest
 */
export interface UpdateSectionRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateSectionRequest
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateSectionRequest
     */
    order?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSectionRequest
     */
    isDraft?: boolean;
}

/**
 * Check if a given object implements the UpdateSectionRequest interface.
 */
export function instanceOfUpdateSectionRequest(value: object): boolean {
    return true;
}

export function UpdateSectionRequestFromJSON(json: any): UpdateSectionRequest {
    return UpdateSectionRequestFromJSONTyped(json, false);
}

export function UpdateSectionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSectionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'order': json['order'] == null ? undefined : json['order'],
        'isDraft': json['isDraft'] == null ? undefined : json['isDraft'],
    };
}

export function UpdateSectionRequestToJSON(value?: UpdateSectionRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'order': value['order'],
        'isDraft': value['isDraft'],
    };
}

